import React, { useEffect, useState } from "react";
import "./OtherTasksView.css";

import { v4 as uuid4 } from "uuid";

import ClickNHold from "react-click-n-hold";
import { TrainingCell } from "../TrainingViews/TrainingCell/TrainingDay";
import GeneralTaskPopup from "../GeneralTask/GeneralTaskPopup";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export default function OtherTasksView({ date, generalTaskArr }) {
  const [fieldAreas, setFieldAreas] = useState([]);
  const [generalTasksDaily, setGeneralTasksDaily] = useState([]);
  const [generalTasksWeekly, setGeneralTasksWeekly] = useState([]);
  const [generalTasksMonthly, setGeneralTasksMonthly] = useState([]);

  const [isDragging, setIsDragging] = useState(false);
  useEffect(() => {
    setGeneralTasksDaily(generalTaskArr?.filter((task) => task.tasktype == 1));
    setGeneralTasksWeekly(generalTaskArr?.filter((task) => task.tasktype == 2));
    setGeneralTasksMonthly(
      generalTaskArr?.filter((task) => task.tasktype == 3)
    );
  }, [generalTaskArr]);

  const onNewGeneralTaskClick = (taskType) => {
    let option = {
      date: date,
      taskType,
    };
    new GeneralTaskPopup().showPopup(option, null, () => {});
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const getGeneralTaskOfType = (type) => {
    if (type == 1) return generalTasksDaily;
    if (type == 2) return generalTasksWeekly;
    return generalTasksMonthly;
  };

  const setGeneralTasksOfType = (new_items, type) => {
    if (type == 1) return setGeneralTasksDaily(new_items);
    if (type == 2) return setGeneralTasksWeekly(new_items);
    return setGeneralTasksMonthly(new_items);
  };

  const onDragEnd = (result, type) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      getGeneralTaskOfType(type),
      result.source.index,
      result.destination.index
    );

    const ids = items.map((task) => task.Id);
    window.DataGate.reorderGeneralTasks(ids, () => {});
    setIsDragging(false);
    setGeneralTasksOfType(items, type);
  };
  const renderGeneralTaskTableDaily = () => {
    const currentTasks = generalTasksDaily;
    return (
      <div>
        <table
          className="riderTableR otherTasksViewTable"
          style={{ maxWidth: "350px" }}
        >
          <thead>
            <tr>
              <td>Other tasks</td>
            </tr>
          </thead>
          <DragDropContext
            onDragEnd={(result) => onDragEnd(result, 1)}
            onBeforeDragStart={() => setIsDragging(true)}
          >
            <Droppable droppableId={"droppable-area-daily"}>
              {(provided, snapshot) => (
                <tbody {...provided.droppableProps} ref={provided.innerRef}>
                  {currentTasks &&
                    currentTasks.map((i, index) => (
                      <Draggable
                        key={Math.uuid()}
                        draggableId={"daily-" + i.Name + "-" + index}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                            }}
                          >
                            <td
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => onGeneralTaskClick(i, 1)}
                            >
                              <div>
                                <div style={{ fontSize: "0.6em" }}>
                                  {i.TimeOfDay}
                                </div>
                                <span
                                  className="otherTasksViewTable--task-name"
                                  style={
                                    i.Color == "green"
                                      ? {
                                          fontWeight: "bold",
                                          textDecoration: "line-through",
                                          textShadow: "none",
                                        }
                                      : {
                                          fontWeight: "bold",
                                          color: "red",
                                        }
                                  }
                                >
                                  {window.DataStorage.allUsers.length
                                    ? i.TrainerId
                                      ? i.Name +
                                        " (" +
                                        window.getInitials(
                                          window.DataStorage.allUsers.find(
                                            (t) => t.Id == i.TrainerId
                                          ).Name
                                        ) +
                                        ")"
                                      : i.Name + "(N)"
                                    : i.Name}
                                </span>
                                <div style={{ fontSize: "0.6em" }}>
                                  {i.Remark}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}

                  <tr>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => onNewGeneralTaskClick(1)}
                    >
                      Add new task
                    </td>
                  </tr>
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        </table>
      </div>
    );
  };
  const renderGeneralTaskTableWeekly = () => {
    const currentTasks = generalTasksWeekly;
    return (
      <div>
        <table className="riderTableR otherTasksViewTable">
          <thead>
            <tr>
              <td>Weekly tasks</td>
            </tr>
          </thead>
          <DragDropContext
            onDragEnd={(result) => onDragEnd(result, 2)}
            onBeforeDragStart={() => setIsDragging(true)}
          >
            <Droppable droppableId={"droppable-area-weekly"}>
              {(provided, snapshot) => (
                <tbody {...provided.droppableProps} ref={provided.innerRef}>
                  {currentTasks &&
                    currentTasks.map((i, index) => (
                      <Draggable
                        key={Math.uuid()}
                        draggableId={"weekly-" + i.Name + "-" + index}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                            }}
                          >
                            <td
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => onGeneralTaskClick(i, 2)}
                            >
                              <div>
                                <div style={{ fontSize: "0.6em" }}>
                                  {i.TimeOfDay}
                                </div>
                                <span
                                  className="otherTasksViewTable--task-name"
                                  style={
                                    i.Color == "green"
                                      ? {
                                          fontWeight: "bold",
                                          textDecoration: "line-through",
                                          textShadow: "none",
                                        }
                                      : {
                                          fontWeight: "bold",
                                          color: "red",
                                        }
                                  }
                                >
                                  {window.DataStorage.allUsers.length
                                    ? i.TrainerId
                                      ? i.Name +
                                        " (" +
                                        window.getInitials(
                                          window.DataStorage.allUsers.find(
                                            (t) => t.Id == i.TrainerId
                                          ).Name
                                        ) +
                                        ")"
                                      : i.Name + "(N)"
                                    : i.Name}
                                </span>
                                <div style={{ fontSize: "0.6em" }}>
                                  {i.Remark}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}

                  <tr>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => onNewGeneralTaskClick(2)}
                    >
                      Add new task
                    </td>
                  </tr>
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        </table>
      </div>
    );
  };
  const renderGeneralTaskTableMonthly = () => {
    const currentTasks = generalTasksMonthly;
    return (
      <div>
        <table className="riderTableR otherTasksViewTable">
          <thead>
            <tr>
              <td>Monthly tasks</td>
            </tr>
          </thead>
          <DragDropContext
            onDragEnd={(result) => onDragEnd(result, 3)}
            onBeforeDragStart={() => setIsDragging(true)}
          >
            <Droppable droppableId={"droppable-area-monthly"}>
              {(provided, snapshot) => (
                <tbody {...provided.droppableProps} ref={provided.innerRef}>
                  {currentTasks &&
                    currentTasks.map((i, index) => (
                      <Draggable
                        key={Math.uuid()}
                        draggableId={"monthly-" + i.Name + "-" + index}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                            }}
                          >
                            <td
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => onGeneralTaskClick(i, 3)}
                            >
                              <div>
                                <div style={{ fontSize: "0.6em" }}>
                                  {i.TimeOfDay}
                                </div>
                                <span
                                  className="otherTasksViewTable--task-name"
                                  style={
                                    i.Color == "green"
                                      ? {
                                          fontWeight: "bold",
                                          textDecoration: "line-through",
                                          textShadow: "none",
                                        }
                                      : {
                                          fontWeight: "bold",
                                          color: "red",
                                        }
                                  }
                                >
                                  {window.DataStorage.allUsers.length
                                    ? i.TrainerId
                                      ? i.Name +
                                        " (" +
                                        window.getInitials(
                                          window.DataStorage.allUsers.find(
                                            (t) => t.Id == i.TrainerId
                                          ).Name
                                        ) +
                                        ")"
                                      : i.Name + "(N)"
                                    : i.Name}
                                </span>
                                <div style={{ fontSize: "0.6em" }}>
                                  {i.Remark}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}

                  <tr>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => onNewGeneralTaskClick(3)}
                    >
                      Add new task
                    </td>
                  </tr>
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        </table>
      </div>
    );
  };

  const onGeneralTaskClick = (task, taskType) => {
    let options = {
      date: new Date(task.Time),
    };
    new GeneralTaskPopup().showPopup(options, task, () => {});
  };

  return (
    <div className="otherTasksViewHolderWrapper">
      <div className="otherTasksViewHolder otherTasksViewHolderScrollArea">
        <div style={{ flex: 1, maxWidth: "350px" }}>
          {renderGeneralTaskTableDaily()}
        </div>
        <div style={{ flex: 1, maxWidth: "350px" }}>
          {renderGeneralTaskTableWeekly()}
        </div>
        <div style={{ flex: 1, maxWidth: "350px" }}>
          {renderGeneralTaskTableMonthly()}
        </div>
      </div>
    </div>
  );
}
